import {
  FETCH_TICKETS_BEGIN,
  FETCH_TICKETS_SUCCESS,
  FETCH_TICKETS_FAILURE,
  RESET_REDUX,
  RESET_ON_IMPERSONATION
} from '../../actions/actionTypes';

const initialState = {
  request: null,
  tickets: [],
  filteredTickets: [],
  numberOfTickets: 0,
  loading: false,
  errors: null,
  initialDataCollected: false,
};

const ticketsReducer = ( state = initialState, action:any ) => {
  switch(action.type) {
    case FETCH_TICKETS_BEGIN:
      return {
        ...state,
        loading: true,
        request: action.payload,
        errors: null,
      };

    case FETCH_TICKETS_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload.ticketsResponse.tickets,
        filteredTickets: action.payload.ticketsResponse.tickets,
        numberOfTickets: action.payload.ticketsResponse.count,
        initialDataCollected: true,
      };

    case FETCH_TICKETS_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        tickets: [],
        initialDataCollected: true,
      };

    case RESET_REDUX:
      return {...initialState};

    case RESET_ON_IMPERSONATION:
      return {...initialState};

    default:
      return state;
  }
}

export default ticketsReducer;
